import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';
import { ISODateString } from '@mesa-labs/mesa-api/dist/types/general';
import { DateTime } from 'luxon';

export type ScheduledVendorCollectionsState = {
  vendorSearch?: string;
  state?: api.ScheduledVendorCollectionState;
  periodization: api.TimeSeriesPeriodization;
  beginningAt: ISODateString;
  endingAt: ISODateString;
  enforcePeriodization: boolean;
};

export const initialState: ScheduledVendorCollectionsState = {
  vendorSearch: undefined,
  state: undefined,
  periodization: api.TimeSeriesPeriodization.DAY,
  beginningAt: DateTime.now().minus({ days: 30 }).toISO(),
  endingAt: DateTime.now().toISO(),
  enforcePeriodization: false,
};

const scheduledVendorCollectionsSlice = createSlice({
  name: 'scheduledVendorCollections',
  initialState,
  reducers: {
    updateVendorSearch(state: ScheduledVendorCollectionsState, action: PayloadAction<string | undefined>) {
      state.vendorSearch = action.payload;
    },
    updateState(state: ScheduledVendorCollectionsState, action: PayloadAction<api.ScheduledVendorCollectionState | undefined>) {
      state.state = action.payload;
    },
    updatePeriodization(state: ScheduledVendorCollectionsState, action: PayloadAction<api.TimeSeriesPeriodization>) {
      state.periodization = action.payload;
    },
    updateBeginningAt(state: ScheduledVendorCollectionsState, action: PayloadAction<ISODateString>) {
      state.beginningAt = action.payload;
    },
    updateEndingAt(state: ScheduledVendorCollectionsState, action: PayloadAction<ISODateString>) {
      state.endingAt = action.payload;
    },
    updateEnforcePeriodization(state: ScheduledVendorCollectionsState, action: PayloadAction<boolean>) {
      state.enforcePeriodization = action.payload;
    },
  },
});

export const {
  updateVendorSearch,
  updateState,
  updatePeriodization,
  updateBeginningAt,
  updateEndingAt,
  updateEnforcePeriodization,
} = scheduledVendorCollectionsSlice.actions;
export default scheduledVendorCollectionsSlice.reducer;
